if(!customElements.get('learn-more')) {
  class ComponentLearnMore extends HTMLElement {
    constructor() {
      super();

      
      this.less = this.querySelector('.less');
      this.more = this.querySelector('.more');
      this.readMore = this.querySelector('button.read-more');
      this.readLess = this.querySelector('button.read-less');

      this.readMore.addEventListener('click', ()=>{
        this.more.classList.remove('hide');
        this.less.classList.add('hide');
      });

      this.readLess.addEventListener('click', ()=>{
        this.less.classList.remove('hide');
        this.more.classList.add('hide');
      });

    }

  }
  customElements.define('learn-more', ComponentLearnMore);
}